import isAllMessagesRange from "views/logic/queries/IsAllMessagesRange";
import { NO_TIMERANGE_OVERRIDE, RELATIVE_ALL_TIME } from "views/Constants";
import { normalizeIfClassifiedRelativeTimeRange } from "views/components/time-range-picker/RelativeTimeRangeClassifiedHelper";
import {
  isTypeKeyword,
  isTypeRelativeWithEnd,
  isTypeRelativeWithStartOnly,
  isTimeRange
} from "views/typeGuards/timeRange";
import { adjustFormat, toUTCFromTz } from "util/DateTime";
export const normalizeIfAllMessagesRange = (timeRange) => {
  if ("type" in timeRange && isAllMessagesRange(timeRange)) {
    return {
      type: timeRange.type,
      range: RELATIVE_ALL_TIME
    };
  }
  return timeRange;
};
export const normalizeFromPickerForSearchBar = (timeRange) => {
  if (!timeRange) {
    return NO_TIMERANGE_OVERRIDE;
  }
  const normalizeIfKeywordTimeRange = (tr) => {
    if (isTypeKeyword(tr)) {
      return {
        type: tr.type,
        timezone: tr.timezone,
        keyword: tr.keyword
      };
    }
    return tr;
  };
  return normalizeIfKeywordTimeRange(normalizeIfAllMessagesRange(normalizeIfClassifiedRelativeTimeRange(timeRange)));
};
export const normalizeFromSearchBarForBackend = (timerange, userTz, absoluteTimeFormat = "internal") => {
  if (!isTimeRange(timerange)) {
    return void 0;
  }
  const { type } = timerange;
  switch (type) {
    case "absolute":
      return {
        type,
        from: adjustFormat(toUTCFromTz(timerange.from, userTz), absoluteTimeFormat),
        to: adjustFormat(toUTCFromTz(timerange.to, userTz), absoluteTimeFormat)
      };
    case "relative":
      if (isTypeRelativeWithStartOnly(timerange)) {
        return {
          type,
          range: timerange.range
        };
      }
      if (isTypeRelativeWithEnd(timerange)) {
        if ("to" in timerange) {
          return {
            type,
            from: timerange.from,
            to: timerange.to
          };
        }
        return {
          type,
          from: timerange.from
        };
      }
      throw new Error("Invalid relative time range");
    case "keyword":
      return timerange;
    default:
      throw new Error(`Invalid time range type: ${type}`);
  }
};
